import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import cn from 'classnames'
import { compact, isEmpty, keys } from 'lodash'

import { getSelectedMenusIds } from '../selectors/config';
import styles from './SelectMenusModal.module.scss'
import Checkbox from './Checkbox'
import Button from './Button'

class SelectMenusModal extends Component {
  constructor(props) {
    super(props)
    this.state = { selectedIds: [...props.selectedIds], }
  }

  handleChange = e => {
    const { name, checked } = e.target
    this.setState(prevState => {
      return checked
        ? { selectedIds: [...prevState.selectedIds, name] }
        : { selectedIds: prevState.selectedIds.filter(id => id !== name) }
    })
  }

  handleSubmit = e => {
    const { closeModal, onSubmit } = this.props
    e.preventDefault()
    const menuIds = compact(this.state.selectedIds)

    onSubmit(menuIds)
    closeModal()
  }

  renderMenuRow = menu => {
    return (
      <li key={menu.uuid}>
        <Checkbox
          label={menu.name}
          name={menu.uuid}
          handleChange={this.handleChange}
          checked={this.state.selectedIds.includes(menu.uuid)}
        />
      </li>
    )
  }

  renderMenusList = menus => (
    keys(menus).map(standUuid => {
      const stand = this.props.stands.find(stand => stand.uuid === standUuid)
      const rows = menus[standUuid].map(menu => this.renderMenuRow(menu))
      return (
        <div key={standUuid} className={styles.menusListModal__menuGroup}>
          <h3 className={styles.menusListModal__groupHeader}>{stand?.name}</h3>
          {rows}
        </div>
      )
    })
  )

  render() {
    const { selectedIds } = this.state
    const { menus, isOpen, closeModal } = this.props
    const isMenuSelected = isEmpty(selectedIds)

    return (
      <div>
        <Modal
          className={cn(styles.menusListModal, "modal")}
          isOpen={isOpen}
          overlayClassName="overlay -higher-layer"
        >
          <header>
            <h1>Menus list</h1>
          </header>
          {isMenuSelected && <p>At least one menu has to be chosen</p>}
          <ul className={styles.menusListModal__menusList}>
            {this.renderMenusList(menus)}
          </ul>
          <footer className={styles.menusListModal__footer}>
            <Button
              onClick={this.handleSubmit}
              disabled={isMenuSelected}
              className={styles.menusListModal__button}
            >
              Submit
            </Button>
            <Button onClick={closeModal}>Cancel</Button>
          </footer>
        </Modal>
      </div>
    )
  }
}

SelectMenusModal.propTypes = {
  menus: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      })
    )
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
  selectedIds: PropTypes.array.isRequired,
}

const mapStateToProps = state => ({
  selectedIds: getSelectedMenusIds(state)
})

export default connect(mapStateToProps)(SelectMenusModal)
